import { Injectable } from '@angular/core';

import { licenciamentosStorage } from "./data.service";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";

@Injectable()
export class LicenciamentosService {

    constructor(
        private _autocompleteService: AutoCompleteService
    ) { }

    //session
    setSessionStorage(item: any) {
        var object: string = JSON.stringify(item);
        sessionStorage.setItem(licenciamentosStorage + '-new', object);
    }

    getSessionStorage() {
        var item: string = sessionStorage.getItem(licenciamentosStorage + "-new");
        return JSON.parse(item);
    }

    clearSessionStorage() {
        sessionStorage.removeItem(licenciamentosStorage + "-new");
    }

    returnToOtherForm(otherForm: string, Response: any) {

    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/licenciamentos/shared/licenciamento.service.ts
 **/